import client from './client';

const getDatasByMachineForPeriod = (datas) => client.post("/getDatasByMachineForPeriod", datas);

export default
{
    getDatasByMachineForPeriod
}